import axios from 'axios'

const { domain } = require('../constants/index')

const state = {
    status: ""
}
const getters = {

}
const actions = {


    async saveForm({ commit }, info) {
        let res = await axios.post(domain + '/api/form/save_form', info)
        if (res.data.success) {
            commit('save')
        }
        return res
    },

}

const mutations = {

    save(state) {
        state.status = "Save."
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
